import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/user/view/user.view.query.gql"
import type {
  UserViewQuery,
  UserViewQueryVariables,
} from "@/v2-backoffice-client/user/view/__types__/user.view.query"

type Options = QueryHookOptions<UserViewQuery, UserViewQueryVariables>

export function useUserViewQuery(options?: Options) {
  return useQuery<UserViewQuery, UserViewQueryVariables>(query, options)
}
